import { useEffect, useState } from "react";

const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_57d85e2a-e3d9-489b-aea5-c3202d03fe13/artifacts/xzltz4c8_ChatGPT%20Image%208%20de%20mai.%20de%202026%2C%2018_11_09.png";

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-black/80 backdrop-blur-xl border-b border-white/5"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
                <a
                    href="/"
                    data-testid="header-logo"
                    className="flex items-center gap-3 group"
                >
                    <img
                        src={LOGO_URL}
                        alt="FLUXO NAS VENDAS"
                        className="h-10 w-10 object-contain"
                    />
                    <div className="hidden sm:flex flex-col leading-none">
                        <span className="text-[10px] tag-fluxo">FLUXO</span>
                        <span className="text-[11px] text-white/80 tracking-[0.32em] font-medium font-['Outfit']">
                            NAS VENDAS
                        </span>
                    </div>
                </a>

                <nav className="hidden lg:flex items-center gap-10">
                    {[
                        ["Operação", "como-operamos"],
                        ["Seletividade", "quem-nao-atendemos"],
                        ["Posicionamento", "posicionamento"],
                        ["FAQ", "faq"],
                    ].map(([label, id]) => (
                        <button
                            key={id}
                            data-testid={`nav-${id}`}
                            onClick={() => scrollTo(id)}
                            className="text-[12px] uppercase tracking-[0.25em] text-white/60 hover:text-[#d4af37] transition-colors font-['Outfit']"
                        >
                            {label}
                        </button>
                    ))}
                </nav>

                <button
                    data-testid="header-cta"
                    onClick={() => scrollTo("cta-final")}
                    className="btn-outline-gold px-5 py-2.5 text-[11px] uppercase tracking-[0.25em] font-medium font-['Outfit']"
                >
                    Verificar Elegibilidade
                </button>
            </div>
        </header>
    );
}
